import { Backdrop, BackdropProps, CircularProgress } from '@material-ui/core';

import { useCustomTheme } from '@/hooks/useCustomTheme';

interface LoadingFill extends BackdropProps {
  hideProgress?: boolean;
}

export const LoadingFill = ({ hideProgress, ...props }: LoadingFill) => {
  const { palette } = useCustomTheme();
  return (
    <Backdrop
      style={{ backgroundColor: palette.background.default, zIndex: 1000, position: 'absolute', paddingBottom: 20 }}
      transitionDuration={{ exit: 200 }}
      {...props}
    >
      {!hideProgress && <CircularProgress color={'secondary'} size={36} />}
    </Backdrop>
  );
};
